<div class="input-cell">
    <nb-toggle labelPosition="start" (checkedChange)="onToggle($event)" [(checked)]="checked">{{label}}</nb-toggle>
</div>



